'use client'

import { ToastProvider, ToastViewport } from '@/components/ui/toast'

// Mounts the app's toast viewport (used by useToast across the frontend).
export function Notifications() {
  return (
    <ToastProvider>
      <ToastViewport />
    </ToastProvider>
  )
}
